import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { useAppInsights } from './plugins/application-insights';
useAppInsights().trackEvent({ name: 'App Loaded' })

// Vue.config.productionTip = false;
Vue.config.productionTip = true;

new Vue({
  router,
  store,
  vuetify,
  components: { App },
  render: h => h(App),
}).$mount("#app");
